import React from 'react';
import Header from 'component/layout/header/Header';
import UsersTab from './templates/usersTemplate/users-tab/UsersTab';
import styles from './Users.module.scss';
import SettingsHeader from '../layout/settingsLayout/settingsHeader/SettingsHeader';
import Container from 'component/atom/container/Container';
import RoundedTabs from 'component/atom/Tabs/RoundedTabs';
import GroupsTab from './templates/groupsTemplate/GroupsTab';

const Users = () => {
  const tabs = [
    { label: 'Users', content: <UsersTab /> },
    { label: 'Groups', content: <GroupsTab /> },
  ];

  return (
    <Container>
      <SettingsHeader title='Users' />
      <RoundedTabs tabs={tabs} />
    </Container>
  );
};

export default Users;
